export class State {
  constructor(public name: string, public stateCode: string) { }
}


export const STATES: Array<State> = [
  {
    name: 'Alabama, USA',
    stateCode: 'AL'
  },
  {
    name: 'Alaska, USA',
    stateCode: 'AK'
  },
  {
    name: 'American Samoa, USA',
    stateCode: 'AS'
  },
  {
    name: 'Arizona, USA',
    stateCode: 'AZ'
  },
  {
    name: 'Arkansas, USA',
    stateCode: 'AR'
  },
  {
    name: 'California, USA',
    stateCode: 'CA'
  },
  {
    name: 'Colorado, USA',
    stateCode: 'CO'
  },
  {
    name: 'Connecticut, USA',
    stateCode: 'CT'
  },
  {
    name: 'Delaware, USA',
    stateCode: 'DE'
  },
  {
    name: 'District Of Columbia, USA',
    stateCode: 'DC'
  },
  {
    name: 'Florida, USA',
    stateCode: 'FL'
  },
  {
    name: 'Georgia, USA',
    stateCode: 'GA'
  },
  {
    name: 'Guam, USA',
    stateCode: 'GU'
  },
  {
    name: 'Hawaii, USA',
    stateCode: 'HI'
  },
  {
    name: 'Idaho, USA',
    stateCode: 'ID'
  },
  {
    name: 'Illinois, USA',
    stateCode: 'IL'
  },
  {
    name: 'Indiana, USA',
    stateCode: 'IN'
  },
  {
    name: 'Iowa, USA',
    stateCode: 'IA'
  },
  {
    name: 'Kansas, USA',
    stateCode: 'KS'
  },
  {
    name: 'Kentucky, USA',
    stateCode: 'KY'
  },
  {
    name: 'Louisiana, USA',
    stateCode: 'LA'
  },
  {
    name: 'Maine, USA',
    stateCode: 'ME'
  },
  {
    name: 'Maryland, USA',
    stateCode: 'MD'
  },
  {
    name: 'Massachusetts, USA',
    stateCode: 'MA'
  },
  {
    name: 'Michigan, USA',
    stateCode: 'MI'
  },
  {
    name: 'Minnesota, USA',
    stateCode: 'MN'
  },
  {
    name: 'Mississippi, USA',
    stateCode: 'MS'
  },
  {
    name: 'Missouri, USA',
    stateCode: 'MO'
  },
  {
    name: 'Montana, USA',
    stateCode: 'MT'
  },
  {
    name: 'Nebraska, USA',
    stateCode: 'NE'
  },
  {
    name: 'Nevada, USA',
    stateCode: 'NV'
  },
  {
    name: 'New Hampshire, USA',
    stateCode: 'NH'
  },
  {
    name: 'New Jersey, USA',
    stateCode: 'NJ'
  },
  {
    name: 'New Mexico, USA',
    stateCode: 'NM'
  },
  {
    name: 'New York, USA',
    stateCode: 'NY'
  },
  {
    name: 'North Carolina, USA',
    stateCode: 'NC'
  },
  {
    name: 'North Dakota, USA',
    stateCode: 'ND'
  },
  {
    name: 'Ohio, USA',
    stateCode: 'OH'
  },
  {
    name: 'Oklahoma, USA',
    stateCode: 'OK'
  },
  {
    name: 'Oregon, USA',
    stateCode: 'OR'
  },
  {
    name: 'Pennsylvania, USA',
    stateCode: 'PA'
  },
  {
    name: 'Puerto Rico, USA',
    stateCode: 'PR'
  },
  {
    name: 'Rhode Island, USA',
    stateCode: 'RI'
  },
  {
    name: 'South Carolina, USA',
    stateCode: 'SC'
  },
  {
    name: 'South Dakota, USA',
    stateCode: 'SD'
  },
  {
    name: 'Tennessee, USA',
    stateCode: 'TN'
  },
  {
    name: 'Texas, USA',
    stateCode: 'TX'
  },
  {
    name: 'Utah, USA',
    stateCode: 'UT'
  },
  {
    name: 'Vermont, USA',
    stateCode: 'VT'
  },
  {
    name: 'Virgin Islands, USA',
    stateCode: 'VI'
  },
  {
    name: 'Virginia, USA',
    stateCode: 'VA'
  },
  {
    name: 'Washington, USA',
    stateCode: 'WA'
  },
  {
    name: 'West Virginia, USA',
    stateCode: 'WV'
  },
  {
    name: 'Wisconsin, USA',
    stateCode: 'WI'
  },
  {
    name: 'Wyoming, USA',
    stateCode: 'WY'
  }
];
